import {
  RESIZE_COLUMN,
  RESIZE_COLUMN_FINISHED,
  SET_ROW_NUMBER_OF_COLUMNS,
  SET_ROW_PADDING,
  SET_ROW_MARGIN
} from './action-names';

export function resizeColumn(data) {
  return {
    type: RESIZE_COLUMN,
    ...data
  };
};

export function resizeColumnFinished(data) {
  return {
    type: RESIZE_COLUMN_FINISHED,
    ...data
  };
};

export function setRowNumberOfColumns(data) {
  return {
    type: SET_ROW_NUMBER_OF_COLUMNS,
    ...data
  };
};

export function setRowPadding(data) {
  return {
    type: SET_ROW_PADDING,
    ...data
  };
};

export function setRowMargin(data) {
  return {
    type: SET_ROW_MARGIN,
    ...data
  };
};


// WEBPACK FOOTER //
// ./app/header-builder/actions/row-actions.js